import { useModel } from "@rapid/contexts/ModelContext";
import { PromptLabelCard } from "./PromptLabelCard";
import { BuildPromptSteps } from "@rapid/types/flows";
import lodash from "lodash";
import { useMemo } from "react";

export const PromptLabelList = ({
    mode,
    onApprove,
    onReject
}: {
    mode: BuildPromptSteps;
    onApprove?: (classFilter: string) => void;
    onReject?: (classFilter: string) => void;
}) => {
    const { promptLabels, annotationsForFile } = useModel();

    const labels = useMemo(() => {
        const allAnnotations = Object.values(annotationsForFile).flat();
        return lodash.uniq(
            [...Array.from(promptLabels.entries()).map(([label]) => label)].sort((a, b) => {
                // Sort empty annotations to the bottom
                const aIsEmpty = allAnnotations.some((anno) => anno.label === a && anno.empty);
                const bIsEmpty = allAnnotations.some((anno) => anno.label === b && anno.empty);

                if (aIsEmpty && !bIsEmpty) return 1;
                if (!aIsEmpty && bIsEmpty) return -1;
                return a.localeCompare(b);
            })
        );
    }, [annotationsForFile, promptLabels]);

    return (
        <div className="promptLabelList">
            {labels.length > 0 &&
                labels.map((label) => (
                    <PromptLabelCard
                        key={label}
                        name={label}
                        mode={mode}
                        onApprove={onApprove}
                        onReject={onReject}
                        totalLabelsCount={labels.length}
                    />
                ))}
        </div>
    );
};
